import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class ConnectSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'connect-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
